import { render, staticRenderFns } from "./CcAssignmentsAdviceStatusList.vue?vue&type=template&id=5ce953de"
import script from "./CcAssignmentsAdviceStatusList.vue?vue&type=script&lang=ts"
export * from "./CcAssignmentsAdviceStatusList.vue?vue&type=script&lang=ts"
import style0 from "./CcAssignmentsAdviceStatusList.vue?vue&type=style&index=0&id=5ce953de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports